// ChatGPT: new hook to debounce values
// Bounces the input: If you type "glucose" quickly, it waits until you stop typing for 300ms before searching. 
// This prevents 7 searches (g, gl, glu, gluc, gluco, glucos, glucose) and only does 1
import { useState, useEffect } from 'react';

export default function useDebounce(value, delay = 300) { // ChatGPT: added
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
